import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceHelperService } from '../service-helper.service';
import data from 'highcharts/modules/data';
import { map } from 'rxjs/internal/operators/map';


@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  htmlResponse: string;




  constructor(private http: HttpClient,
    private svcHelper: ServiceHelperService ) { }
    

 
    AddPayment(formData: FormData) {

      const body = {};
      formData.forEach((value, key) => {
        body[key] = value;
      });
      
      const url = `${this.svcHelper.getUrl('Payment/addSubscription')}`;
      return this.http.post(url,body,{observe: 'response'});

      
    }


    getSubsByEmail(Email){
     
      const url = `${this.svcHelper.getUrl(`Payment/getAbonnementsByUser/${Email}`)}`;
      return this.http.get(url);
    }


 
  
    getUserByEmail(Email){
     
      const url = `${this.svcHelper.getUrl(`Admin/getuserbyemail/${Email}`)}`;
      return this.http.get(url);
    }
     

    getActualSubByEmail(Emailus){
     
      const url = `${this.svcHelper.getUrl(`Payment/getCurrentSubscription/${Emailus}`)}`;
      return this.http.get(url);
    }


    checkActiveSub(email){
     
      const url = `${this.svcHelper.getUrl(`Payment/VerifySubscription/${email}`)}`;
      return this.http.get(url);
    }

    endSub(email){
      const body = {email :email};
      const url = `${this.svcHelper.getUrl('Payment/endSubscription')}`;
      return this.http.post(url,body,{observe: 'response'});
    }
    

    }
  




